export * from '@cipafacil/lib/mock-api/mock-api.constants';
export * from '@cipafacil/lib/mock-api/mock-api.module';
export * from '@cipafacil/lib/mock-api/mock-api.service';
export * from '@cipafacil/lib/mock-api/mock-api.types';
export * from '@cipafacil/lib/mock-api/mock-api.utils';
